const errorEmail = 'El campo debe contener un correo electrónico valido';

export default {
  actions: {
    search: 'Buscar',
    sendTokenAsign: 'Reenviar token a responsable',
    selectSearch: 'Editor de búsqueda',
    exactSearch: 'Búsqueda exacta',
    optionsSearch: 'Tipo de filtrado',
    selectedSearch: 'Campos seleccionados',
    detail: 'Detalle',
    delete: 'Eliminar',
    saveExit: 'Guardar y Salir',
    save: 'Guardar',
    add: 'Agregar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    edit: 'Editar',
    editRoot: 'Editar root',
    request_update: 'Solicitar cambio',
    activate: 'Activar',
    deactivate: 'Desactivar',
    select_one: 'Seleccione...',
    moreActions: 'Más acciones',
    exportCSV: 'Exportar a CSV',
    exportXLSX: 'Exportar a XLSX',
    disable: 'Dar de baja',
    enable: 'Recuperar',
    addOther: 'Agregar otro',
    addLocation: 'Agregar ubicación',
    exportPDF: 'Exportar a PDF',
    custodyVoucher: 'Vale de resguardo',
    exportPDFprice: 'Exportar a PDF con precio',
    accept: 'Aceptar',
    reject: 'Rechazar',
    noDischarged: 'No dados de baja',
    discharged: 'Dados de baja',
    all: 'Todos',
    noChangesToReview: 'Sin cambios por revisar',
    changesToReview: 'Cambios por revisar',
    qr_url: 'QR URL',
    qr_name: 'QR Nombre',
    qr_info: 'QR Información',
    barcode: 'Código de barras',
    regenerateCodes: 'Regenerar códigos',
    download_report_companies: 'Descargar reporte de compañías',
  },
  common: {
    createdAt: 'Fecha de creación',
    files: 'Haga click para seleccionar sus archivos o arrastrelos aquí',
    filesActive: 'Suelte los archivos',
    filesLimits: (size, acepted) =>
      `Haga click para seleccionar sus archivos o arrastrelos aqu\nPeso máximo: ${size}\nFormatos soportados: ${acepted}`,
    file: 'Haga click para seleccionar el archivo o arrastrelo aquí',
    fileActive: 'Suelte el archivo',
    actions: 'Acciones',
    error: 'Error',
    success: 'Éxito',
    status: 'Estatus',
    active_male: 'Activo',
    active_female: 'Activa',
    deactivated_male: 'Desactivado',
    deactivated_female: 'Desactivada',
    yes: 'Si',
    no: 'No',
    loading: 'Cargando',
  },

  months: {
    1: 'Ene.',
    2: 'Feb.',
    3: 'Mar.',
    4: 'Abr.',
    5: 'May.',
    6: 'Jun.',
    7: 'Jul.',
    8: 'Ago.',
    9: 'Sep.',
    10: 'Oct.',
    11: 'Nov.',
    12: 'Dic.',
  },

  success: {
    custody_voucher_saved: 'Se guardó el vale de resguardo firmado en los archivos del activo.',
    employee_custody_voucher_saved:
      'Se guardó el vale de resguardo firmado en los archivos de cada activo del resguardante.',
    recover_password:
      'Si ingresaste correctamente tu correo electrónico te enviaremos las instrucciones para recuperar tu contraseña.',
    reset_password: 'Tu contraseña fue actualizada, ahora puedes iniciar sesión.',
    token_send: 'Se ha enviado con éxito el token de asignación de activo.',
    toggle_company: 'Se ha actualizado la compañía.',
    delete_company: 'Se ha eliminado la compañía.',
    create_company: 'Se ha agregado la compañía.',
    edit_company: 'Se ha modificado la compañía.',
    add_user: 'Se ha agregado el usuario',
    toggle_user: 'Se ha actualizado el usuario',
    update_user: 'Se ha actualizado el usuario',
    add_notification_config: 'Se ha agregado el perfil de notificación',
    toggle_notification_config: 'Se ha actualizado el perfil de notificación',
    update_notification_config: 'Se ha actualizado el perfil de notificación',
    add_role: 'Se ha agregado el rol',
    update_role: 'Se ha actualizado el rol',
    complete_info: 'Has completado tu información, ahora puedes iniciar sesión',
    create_subcompany: 'Se ha agregado la empresa.',
    edit_subcompany: 'Se ha modificado la empresa.',
    toggle_subcompany: 'Se ha actualizado la empresa.',
    delete_subcompany: 'Se ha eliminado la empresa.',
    add_asset: 'Se ha agregado el activo.',
    update_asset: 'Se ha modificado el activo.',
    disable_asset: 'Se ha dado de baja el activo.',
    enable_asset: 'Se ha recuperado el activo.',
    import_assets: 'Se han importado los activos.',
    import: 'Se han importado los datos.',
    toggle_account: 'Se ha actualizado el registro.',
    update_account: 'Se ha actualizado el registro.',
    add_account: 'Se ha agregado el registro.',
    toggle_depreciation: 'Se ha actualizado la depreciación.',
    update_depreciation: 'Se ha actualizado la depreciación.',
    add_depreciation: 'Se ha agregado la depreciación.',
    toggle_cost_centers: 'Se ha actualizado el centro de costos.',
    update_cost_centers: 'Se ha actualizado el centro de costos.',
    add_cost_centers: 'Se ha agregado el centro de costos.',
    toggle_inpc: 'Se ha actualizado el INPC.',
    update_inpc: 'Se ha actualizado el INPC.',
    add_inpc: 'Se ha agregado el INPC.',
    toggle_custom_group: 'Se ha actualizado el grupo.',
    update_custom_group: 'Se ha actualizado el grupo.',
    add_custom_group: 'Se ha agregado el grupo.',
    toggle_exchange: 'Se ha actualizado el tipo de cambio.',
    update_exchange: 'Se ha actualizado el tipo de cambio.',
    add_exchange: 'Se ha agregado el tipo de cambio.',
    toggle_employee: 'Se ha actualizado el empleado.',
    update_employee: 'Se ha actualizado el empleado.',
    add_employee: 'Se ha agregado el empleado.',
    update_catalogs: 'Se ha actualizado el catálogo.',
    update_locations: 'Se han actualizado las ubicaciones.',
    add_project: 'Se ha agregado el proyecto.',
    update_project: 'Se ha actualizado el proyecto.',
    toggle_project: 'Se ha actualizado el proyecto.',
    toggle_providers_clients: 'Se ha actualizado el proveedor.',
    update_providers_clients: 'Se ha actualizado el proveedor.',
    add_providers_clients: 'Se ha agregado el proveedor',
    accept_historic: 'Se han aceptado los cambios',
    reject_historic: 'Se han rechazado los cambios',
    request_update_asset:
      'Se ha creado un registro de los cambios, el cual deberá ser aprobado para que se puedan reflejar en el activo modificado',
    asset_in: 'Entró activo',
    asset_out: 'Salió activo',
    asset_needs_authorization: 'Se registro la petición de salida, en espera de autorización',
    asset_authorized_out: 'Se autorizó la salida del activo',
    asset_not_authorized_out: 'Se rechazó la salida del activo',
  },
  error: {
    subcompany_forbidden: 'No tienes acceso a esta subcompañía.',
    custody_voucher: {
      file_required: 'No se recibió el PDF del vale.',
      single_file: 'Envía un solo PDF.',
      too_large: 'El PDF del vale pasa de 10 MB.',
      bad_file_name: 'El nombre del archivo del vale no es válido.',
      not_pdf: 'El archivo del vale no es un PDF.',
      no_custodian: 'El activo no tiene resguardante.',
      bad_employee: 'Falta el resguardante del vale.',
      bad_assets: 'La lista de activos del vale no es válida.',
      too_many_assets: 'El vale ampara demasiados activos (máximo 500).',
      other_custodian: 'Uno de los activos tiene otro resguardante.',
      inactive_asset: 'Uno de los activos está inactivo o dado de baja.',
      incomplete:
        'Vale incompleto: debe incluir todos los activos del resguardante. ' +
        'Quita la búsqueda y vuelve a intentarlo.',
      changed:
        'Los activos cambiaron mientras se guardaba el vale. No se guardó; inténtalo de nuevo.',
    },
    asset_not_found: 'No se encontró el activo.',
    employee_not_found: 'No se encontró el resguardante.',
    cannot_upload: 'No se pudo subir el archivo, inténtalo de nuevo.',
    download_image: 'No se pudo descargar la imagen, inténtalo de nuevo',
    generate_pdf: 'No se pudo generar el PDF del activo, inténtalo de nuevo',
    session_expired: 'Tu sesión ha expirado',
    session_terminated: 'Se ha iniciado sesión en otro dispositivo',
    verify: 'Verifica los campos',
    server_error: 'Ocurrió un error al comunicarse con el servidor, intentalo más tarde',
    required: 'El campo es requerido',
    format: 'El formato es inválido',
    minLength: 'El campo es requerido',
    type: 'El campo es requerido',
    email: errorEmail,
    bad_credentials: 'Los datos de acceso no son válidos',
    bad_token: 'El token ha expirado o ya ha sido utilizado',
    company_not_found: 'No se encuentra la compañía o esta desactivada.',
    user_already_exists: 'Ya se ha agregado un usuario con este correo electrónico',
    add_duplicate_key: 'La clave ya ha sido usada',
    asset_already_in: 'El activo ya esta dentro',
    asset_already_out: 'El activo ya esta fuera',
    asset_is_in: 'El activo se encuentra dentro',
    asset_out_needs_message: 'Se requiere mensaje para retiro',
    asset_needs_authorization: 'Se requiere autorización para proceder',
    asset_needs_asset_level: 'Se requiere un nivel de activo',
    asset_needs_employee: 'Se necesita un responsable para retirar',
    asset_can_not_withdraw: 'No puede ser retirado',
    asset: {
      limit_exceded: 'Se excedió el límite de Activos asignados a esta compañía',
      files_limit_exceded: 'Se excedió el límite de archivos por Activo.',
      size_limit_exceded: 'Revisa que el formato y el peso sean soportados.',
      dmsReference: {
        pattern: 'Debe tener entre 8 y 10 caracteres',
      },
    },
    login: {
      email: {
        format: errorEmail,
      },
      password: {
        required: 'El campo debe contener al menos 12 carácteres',
        minLength: 'El campo debe contener al menos 12 carácteres',
      },
    },
    users: {
      email: {
        format: errorEmail,
      },
      limit_exceded: 'Se excedió el límite de Administradores asignados a esta compañía',
      admin_role_forbidden: 'Solo el administrador de la compañía puede asignar o cambiar el rol Administrador.',
      subcompanies_forbidden: 'Solo el administrador de la compañía puede asignar subcompañías.',
      subcompany_not_found: 'Una de las subcompañías elegidas ya no existe en la compañía.',
      subcompanies_not_saved: 'El servidor no guardó las subcompañías. Revisa que el back esté actualizado y vuelve a intentarlo.',
      root_not_editable: 'Los usuarios root no se editan desde esta pantalla: ven todas las subcompañías.',
    },
    recover_password: {
      email: {
        format: errorEmail,
      },
    },
    reset_password: {
      password: {
        minLength: 'La contraseña no puede ser tan corta',
      },
    },
    depreciation_fails: 'No se pudo calcular:',
    user_password_expired:
      'Tu contraseña ha expirado, te hemos enviado un correo electrónico para que ingreses una nueva contraseña.',
    asset_duplicated_number:
      'El número que estas intentando guardar ya esta siendo usado por otro activo.',
  },
  login: {
    title: 'Iniciar Sesión',
    subtitle: 'Somos una empresa especializada en control de activo fijo.',
    fields: {
      email: 'Correo electrónico',
      password: 'Contraseña',
      submit: 'Iniciar Sesión',
      recovery: '¿Olvidaste tu contraseña?',
    },
  },
  recover_password: {
    title: 'Recuperar contraseña',
    subtitle: 'Ingresa el correo electrónico con el que estas registrado.',
    fields: {
      email: 'Correo electrónico',
      submit: 'Enviar',
      login: 'Regresar a Iniciar Sesión',
    },
  },

  reset_password: {
    title: 'Nueva contraseña',
    subtitle: 'Ingresa tu nueva contraseña.',
    fields: {
      password: 'Contraseña',
      submit: 'Enviar',
      login: 'Regresar a Iniciar Sesión',
    },
  },

  complete_info: {
    title: 'Completar registro',
    subtitle: 'Para continuar completa los siguientes datos, después podrás iniciar sesión.',
    fields: {
      name: 'Nombre(s)',
      lastname: 'Apellido(s)',
      password: 'Contraseña',
      submit: 'Enviar',
      login: 'Regresar a Iniciar Sesión',
    },
  },

  update_info: {
    title: 'Actualizar datos',
    subtitle: 'Para continuar completa los siguientes datos, después podrás iniciar sesión.',
    fields: {
      name: 'Nombre(s)',
      lastname: 'Apellido(s)',
      password: 'Contraseña',
      submit: 'Enviar',
      login: 'Regresar a Iniciar Sesión',
    },
  },

  acl: {
    companies: {
      edit: 'Editar la información de la Compañía',
    },
    users: {
      get: 'Listar y buscar Usuarios',
      add: 'Agregar Usuarios',
      update: 'Editar Usuarios',
      toggle: 'Activar/Desactivar Usuarios',
    },
    roles: {
      get: 'Listar y buscar Roles',
      add: 'Agregar Roles',
      update: 'Editar Roles',
      delete: 'Eliminar Roles',
      toggle: 'Activar/Desactivar Roles',
    },
    groups: {
      get: 'Listar y buscar Roles',
      add: 'Agregar Roles',
      update: 'Editar Roles',
      delete: 'Eliminar Roles',
      toggle: 'Activar/Desactivar Roles',
    },

    custom_employee_module: {
      get: 'Listar y buscar Empleados',
      add: 'Agregar Empleados',
      update: 'Editar Empleados',
      delete: 'Eliminar Empleados',
      toggle: 'Activar/Desactivar Empleados',
    },

    custom_employee: {
      get: 'Listar y buscar campos personalizados',
      add: 'Agregar campos personalizados',
      update: 'Editar campos personalizados',
      delete: 'Eliminar campos personalizados',
      toggle: 'Activar/Desactivar campos personalizados',
    },

    custom_group: {
      get: 'Listar y buscar grupo de campos personalizados',
      add: 'Agregar grupo de campos personalizados',
      update: 'Editar grupo de campos personalizados',
      delete: 'Eliminar grupo de campos personalizados',
      toggle: 'Activar/Desactivar grupo de campos personalizados',
    },

    asset_level: {
      get: 'Listar y buscar nivel de activo',
      add: 'Agregar nivel de activo',
      update: 'Editar nivel de activo',
      delete: 'Eliminar nivel de activo',
      toggle: 'Activar/Desactivar nivel de activo',
    },

    assetsFilters: {
      showFilters: 'Mostrar Filtros',
      hideFilters: 'Ocultar Filtros',
    },

    assetsBills: {
      showForm: 'Agregar',
      hideForm: 'Ocultar',
      number: 'Número',
      folio: 'Folio',
      date: 'Fecha',
      import: 'Importe',
      concept: 'Concepto',
      files: 'Archivos',
    },

    assetsCustomsDocuments: {
      showForm: 'Agregar',
      hideForm: 'Ocultar',
      pedimento_number: 'Número de pedimento',
      customs_key: 'Clave aduanera',
      date: 'Fecha de pedimento',
      import: 'Importe',
      quantity: 'Cantidad',
      pedimento_key: 'Clae de pedimento',
      files: 'Archivos',
      total_pedimentos: 'Total de pedimentos',
      accumulated_import: 'Importe acumulado',
      from: 'Desde',
      to: 'Hasta',
      status: 'Estatus',
      save: 'Save',
      createdAt: 'Fecha de creación',
    },

    insOuts: {
      in: 'Registrar ingreso de activo',
      out: 'Solicitar retiro de activo',
      // resolve: "Editar entradas y salidas",
    },

    notification_historic: {
      get: 'Ver historial de notificaciones',
    },

    employees: {
      get: 'Listar y buscar Empleados',
      add: 'Agregar Empleados',
      update: 'Editar Empleados',
      delete: 'Eliminar Empleados',
      toggle: 'Activar/Desactivar Empleados',
    },

    exchanges: {
      title: 'Tipos de cambio',
      get: 'Listar y buscar Tipos de Cambio',
      add: 'Agregar Tipos de Cambio',
      update: 'Editar Tipos de Cambio',
      delete: 'Eliminar Tipos de Cambio',
    },

    inpc: {
      title: 'INPC',
      get: "Listar y buscar INPC's",
      add: "Agregar INPC's",
      update: "Editar INPC's",
      delete: "Eliminar INPC's",
    },

    projects: {
      get: 'Listar y buscar Proyectos',
      add: 'Agregar Proyectos',
      update: 'Editar Proyectos',
      delete: 'Eliminar Proyectos',
      toggle: 'Activar/Desactivar Proyectos',
    },

    assets: {
      get: 'Listar y buscar Activos Fijos',
      add: 'Agregar Activos Fijos',
      update: 'Editar Activos Fijos',
      delete: 'Eliminar Activos Fijos',
      disable: 'Dar de baja Activos Fijos',
      enable: 'Recuperar Activos Fijos dados de baja',
      request_update: 'Solicitar un cambio en un activo',
      review_request_update: 'Aprobar/Rechazar cambio solicitado en un activo',
    },

    cost_centers: {
      title: 'Centros de costros',
      get: 'Listar y buscar Centros de Costos',
      add: 'Agregar Centros de Costos',
      update: 'Editar Centros de Costos',
      delete: 'Eliminar Centros de Costos',
      toggle: 'Activar/Desactivar Centros de Costos',
    },

    clients_providers: {
      get: 'Listar y buscar roles',
      add: 'Agregar roles',
      update: 'Editar roles',
      delete: 'Eliminar roles',
    },

    catalogs: {
      get: 'Listar y buscar Catálogos',
      update: 'Editar Catálogos',
    },

    subcompanies: {
      get: 'Listar y buscar Empresas',
      add: 'Agregar Empresas',
      update: 'Editar Empresas',
      delete: 'Eliminar Empresas',
      toggle: 'Activar/Desactivar Empresas',
    },

    accounts: {
      get: 'Listar y buscar Cuentas y Tipos de activo',
      add: 'Agregar Cuentas y Tipos de activo',
      update: 'Editar Cuentas y Tipos de activo',
      delete: 'Eliminar Cuentas y Tipos de activo',
      toggle: 'Activar/Desactivar Tipos de activo',
    },

    depreciations: {
      get: 'Listar y buscar Depreciaciones',
      add: 'Agregar Depreciaciones',
      update: 'Editar Depreciaciones',
      delete: 'Eliminar Depreciaciones',
      toggle: 'Activar/Desactivar Depreciaciones',
    },

    providers_clients: {
      get: 'Listar y buscar Proveedores',
      add: 'Agregar Proveedores',
      update: 'Editar Proveedores',
      delete: 'Eliminar Proveedores',
      toggle: 'Activar/Desactivar Proveedores',
    },

    reports: {
      disabled: "Consultar el reporte 'Activos dados de baja'",
      depreciation: "Consultar el reporte 'Depreciación por activo fijo'",
      employees_assets: 'Vales de resguardo',
      historics: 'Historial de Activos',
      ins_outs: 'Entradas y salidas',
    },

    import: {
      import: 'Permite importar activos mediante un archivo CSV',
    },

    locations: {
      get: 'Listar ubicaciones',
      update: 'Actualizar ubicaciones',
    },

    mantenimiento_module: {
      get: 'Listar y buscar activos en mantenimiento',
    },

    mantenimiento: {
      get: 'Listar y buscar activos en mantenimiento',
      add: 'Agregar a mantenimiento',
      update: 'Editar mantenimiento',
      toggle: 'Activar/Desactivar Mantenimiento',
    },
    notifications_config: {
      get: 'Listar y buscar configuraciones de notificación',
      add: 'Agregar a configuracion de notificación',
      update: 'Editar perfil de notificación',
      toggle: 'Activar/Desactivar Perfil de notificación',
    },
    notification_historic: {
      get: 'Listar y buscar notificaciones',
    },
    asset_level: {
      get: 'Listar y buscar niveles de activo',
      add: 'Agregar a nivel de activo',
      update: 'Editar nivel de activo',
      delete: 'Eliminar nivel de activo',
      toggle: 'Activar/Desactivar nivel de activo',
    },
    ins_outs: {
      in: 'Registrar ingreso de activo',
      out: 'Solicitar retiro de activo',
      resolve: 'Resolver salida de activo',
    },
    custom_employee: {
      get: 'Listar y buscar custom fields',
      add: 'Agregar a custom fields',
      update: 'Editar custom fields',
      delete: 'Eliminar custom fields',
      toggle: 'Activar/Desactivar custom fields',
    },
    custom_group: {
      get: 'Listar y buscar grupos de custom fields',
      add: 'Agregar a grupos de custom fields',
      update: 'Editar grupos de custom fields',
      delete: 'Eliminar grupos de custom fields',
      toggle: 'Activar/Desactivar grupos de custom fields',
    },
  },
  ins_outs: { title: 'Entradas y salidas' },

  companies: {
    title: 'Compañías',
    form_edit_title: 'Editar compañía',
    form_add_title: 'Agregar compañía',
    permissions: 'Rol',
    delete_title: 'Eliminar compañía',
    typeService: 'Tipo de servicio',
    delete_confirm:
      '¿Esta seguro que desea eliminar la compañía <strong>{{name}}</strong>? * <br/><br/> <small>* La acción no se puede deshacer.</small>',
    fields: {
      name: 'Nombre',
      shortname: 'Nombre corto',
      adminsLimit: 'Cantidad de usuarios Admin por Compañía',
      assetsLimit: 'Cantidad de Activos por Compañía',
      sizePerFile: 'Tamaño de Archivo por Activo, en MB',
      filesPerAsset: 'Cantidad de Archivos por Activo',
      initDate: 'Fecha de Inicio',
      endDate: 'Fecha de Termino',
      salesAgentName: 'Nombre del Agente de Ventas',
      salesAgentEmail: 'Correo del Agente de Ventas',
      isDemo: 'Es demo',
    },
  },

  subcompanies: {
    none_assigned: 'No tienes subcompañías asignadas',
    title: 'Empresas',
    form_edit_title: 'Editar empresa',
    form_add_title: 'Agregar empresa',
    delete_title: 'Eliminar empresa',
    delete_confirm:
      '¿Esta seguro que desea eliminar la empresa <strong>{{name}}</strong>? * <br/><br/> <small>* La acción no se puede deshacer.</small>',
    fields: {
      name: 'Nombre',
      shortname: 'Nombre corto',
    },
  },

  users: {
    title: 'Usuarios',
    subtitle: 'Usuarios',
    usersNotify: 'USUARIOS A NOTIFICAR',
    form_edit_title: 'Editar usuario',
    form_add_title: 'Agregar usuario',
    fields: {
      name: 'Nombre(s)',
      lastname: 'Apellido(s)',
      email: 'Correo electrónico',
      roleId: 'Rol',
      subcompanies: 'Subcompañías',
      all_subcompanies: 'Todas',
      root_all_subcompanies: 'Usuario root: ve todas las subcompañías.',
    },
    searchEditor: {
      name: 'Nombre(s)',
      lastName: 'Apellido(s)',
      email: 'Correo electrónico',
    },
  },

  roles: {
    title: 'Roles',
    subtitle: 'Roles',
    form_edit_title: 'Editar rol',
    form_add_title: 'Agregar rol',
    fields: {
      name: 'Nombre',
      permissions: 'Permisos',
      default: 'Por defecto',
    },
    permissions: {
      key: 'Clave',
      description: 'Descripción',
    },
    searchEditor: {
      name: 'Nombre',
    },
  },

  groups: {
    title: 'Grupos',
    subtitle: 'Grupos',
    form_edit_title: 'Editar grupo',
    form_add_title: 'Agregar grupo',
    fields: {
      key: 'Llave',
      name: 'Nombre',
      description: 'Descripción',
      module: 'Módulo',
      active: 'Activo',
      customs: 'Custom Fields',
    },
    permissions: {
      key: 'Clave',
      description: 'Descripción',
    },
    searchEditor: {
      key: 'Llave',
      name: 'Nombre',
      description: 'Descripción',
      module: 'Módulo',
    },
    moduleDropDown: {
      employees: 'Empleados',
      centerCost: 'Centro de costos',
      providers: 'Proveedores',
      projects: 'Proyectos',
      typeAssets: 'Tipo de activo',
      contableAccounts: 'cuentas_contables',
      depreciations: 'Depreciaciones',
      assets: 'Activos',
    },
  },

  pagination: {
    prev: '<',
    next: '>',
    show: 'Mostrando',
    of: 'de',
    per_page: 'por página',
  },

  assets: {
    title: 'Activos Fijos',
    subtitle: 'Activos Fijos',
    add: 'Agregar activo fijo',
    edit: 'Editar activo fijo',
    detail: 'Detalle activo fijo',
    disable: 'Dar de baja activo fijo',
    depreciation: 'Depreciación Acumulada',
    depreciationPercentage: '% Depreciación Acumulada',
    depreciation_financial: 'Depreciación Financiera',
    depreciation_fiscal: 'Depreciación Fiscal',
    depreciation_info: 'Información del activo',
    depreciation_values: 'Cálculo de depreciación',
    depreciable: 'Valor por depreciar',
    enable_title: 'Recuperar activo fijo',
    enable_confirm:
      '¿Esta seguro que deseas recuperar el activo <strong>"{{number}} - {{name}}"</strong> que habia sido dado de baja? * <br/><br/> <small>* La acción no se puede deshacer.</small>',
    subtitle_monts_and_records_assets: 'Sumatoria de montos y activos',
    amount_and_assets_per_page: "Monto y activos por página",
    amount_and_record_of_all_assets: "Monto y registro de todos los activos",
    totalMoney: 'Monto total',
    totalCount: 'Total de activos',
    section: {
      disable: 'Detalle de la baja',
      accountant: 'Contable',
      assurance: 'Seguro',
      in_out: 'Entradas y Salidas',
      bill: 'Factura',
      bills: 'Facturas',
      customs_documents: 'Información aduanera',
      customs_documents_title: 'Pedimentos de importación',
      buy: 'Compra',
      customFields: 'Campos personalizados',
      general: 'General',
      location: 'Ubicación',
      project: 'Proyecto',
      files: 'Archivos',
      form: 'Datos',
      depreciation: 'Depreciación',
      notes: 'Notas',
      historic: 'Historial',
      codes: 'Códigos',
      downloadQR: 'Descarga código QR',
      downloadBarcode: 'Descarga código de barras',
      regenerateCode: 'Regenerar códigos',
      codes: {
        title_qrUrl: 'Código QR con URL del activo',
        title_qrName: 'Código QR con nombre del activo',
        title_qrData: 'Código QR con información del activo',
        title_barcode: 'Código de barras',
        codeLabel: 'Descarga de códigos',
        fields_data_asset: {
          name: 'Nombre',
          number: 'Número',
          brand: 'Marca',
          model: 'Modelo',
          serie: 'Número de serie',
          employee: 'Responsable',
          location: 'Ubicación',
          createdAt: 'Fecha de creación',
          updatedAt: 'Última actualización',
        },
        info: {
          qrUrl:
            'Este código QR contiene la URL acortada del activo, redirigiendo al sistema SAAF.',
          qrName: 'Este código QR está compuesto por la cuenta, subcuenta y número del activo.',
          qrData: 'Este código QR contiene la siguiente información del activo en texto plano:',
          barcode:
            'Este código de barras está compuesto por la cuenta, subcuenta y número del activo.',
        },
        format: {
          pdf: 'PDF',
          docx: 'DOCX',
          png: 'PNG',
          png_qr: 'PNG QR',
          png_barcode: 'PNG código de barras',
        },
      },
    },
    fields: {
      bills: 'Facturas',
      files: 'Archivos',
      consecutive: 'Consecutivo',
      asset_level: 'Nivel de Activo',
      level: 'Nivel de Activo',
      account: 'Cuenta(Nombre)',
      accountKey: 'Cuenta(Clave)',
      billConcept: 'Concepto en la factura',
      billDate: 'Fecha de factura',
      billFolio: 'Folio de factura',
      billNumber: 'Número de factura',
      billImport: 'Importe de factura',
      dmsReference: 'Referencia DMS',
      custodyNotes: 'Notas del vale de resguardo',
      custodyNotesHelp: 'Una línea por cada cosa que se entrega con el activo (tarjeta de circulación, llaves, accesorios…)',
      customs_documents_pedimento_number: 'Número de pedimento',
      customs_documents_customs_key: 'Clave aduanera',
      customs_documents_date: 'Fecha de pedimento',
      customs_documents_pedimento_key: 'Clave de pedimento',
      customs_documents_import: 'Importe de pedimento',
      customs_documents_quantity: 'Cantidad',
      customs_documents_upload_files: 'Subir archivo',
      brand: 'Marca',
      buyCondition: 'Condición de compra',
      buyDate: 'Fecha de compra',
      buyOrder: 'Orden de compra',
      ApprovalNumber: 'No. de aprobación',
      createdAt: 'Fecha de creación',
      coin: 'Moneda',
      costCenter: 'Centro costos',
      country: 'País',
      description: 'Descripción',
      dollarAssetPrice: 'Precio de compra activo dólares',
      insurable: 'Asegurable',
      insuranceCarrier: 'Aseguradora',
      insurancePercent: 'Porcentaje asegurado',
      insurancePolicy: 'Póliza de seguro',
      financialDepreciation: 'Depreciación financiera',
      fiscalDepreciation: 'Depreciación fiscal',
      usefulLifeOriginal: 'Vida útil original',
      location: 'Ubicación',
      life: 'Tiempo uso (años)',
      model: 'Modelo',
      name: 'Nombre',
      number: 'Número',
      physicalState: 'Estado Físico',
      prefix: 'Prefijo',
      price: 'Precio',
      priceDollars: 'Precio en dólares',
      currentMonthDep: 'Meses dep. periodo actual',
      totalMonthYearsDep: 'A. meses dep. en ejercicios anteriores',
      totalMonthYearsDepAct: 'A. meses dep. en ejercicios al actual',
      totalMonthLife: 'Total de meses a depreciarse',
      monthlyDepDollars: 'Depreciación mensual USD',
      monthlyDep: 'Depreciación mensual',
      moi: 'M.O.I (recalculado)',
      exchange: 'Tipo de cambio',
      project: 'Proyecto',
      projectPrice: 'Costo proyecto',
      provider: 'Proveedor',
      serie: 'Número de serie',
      startDate: 'Fecha de aplicación',
      status: 'Estatus',
      subaccount: 'Tipo',
      sublocation: 'Ubicación nivel',
      asignedEmployeeDate: 'Fecha de Responsable asignado',
      employee: 'Responsable',
      validated: 'Estatus Responsable',
      validatedDate: 'Fecha de validación de Responsable',
      depreciationName: 'Depreciación aplicada',
      remainingLife: 'Vida remanente',
      endDate: 'Fecha de los valores',
      lifeTime: 'Vida útil (años)',
      currentDepreciation: 'Depreciación periodo actual',
      lastDepreciation: 'Depreciación periodo anterior',
      inpcStart: 'INPC adquisición',
      inpcEnd: 'INPC utilización',
      factor: 'Factor actualización',
      lastDepreciationRecalculated: 'Depreciación periodo actual recalculada',
      totalDepreciation: 'Depreciación total',
      depreciable: 'Valor neto de reposición',
      img_asset: 'Activo',
      img_employee: 'Empleado',
      notes: {
        text: 'Nota',
        createdBy: 'Creado por',
        createdAt: 'Fecha de creación',
        notSaved: 'Pendiente',
        empty: 'No se han agregado notas aún',
      },
      historics: {
        field: 'Campo',
        after: 'Valor nuevo',
        before: 'Valor anterior',
        hide: 'Ocultar cambios',
        show: 'Mostrar cambios',
        date: 'Fecha',
        user: 'Usuario',
        status: 'Status',
        empty: 'No se han registrado cambios aún',
        statusName: {
          ACCEPTED: 'Aceptado',
          REJECTED: 'Rechazado',
          PENDING: 'Pendiente',
        },
        buttonFilters: {
          showFilters: 'Mostrar Filtros',
          hideFilters: 'Ocultar Filtros',
        },
        searchEditor: {
          billNumber: 'Numero de factura',
          billFolio: 'Folio de factura',
          billConcept: 'Concepto de factura',
          consecutive: 'Consecutivo',
          prefix: 'Prefijo',
          number: 'Número',
          name: 'Nombre',
          description: 'Descripción',
          account: 'Cuenta contable',
          subAccount: 'Tipo',
          costCenter: 'Centro de costos',
          employee: 'Empleado',
          provider: 'Proveedor',
          buyOrder: 'Orden de compra',
          serie: 'Serie',
          file: 'Archivo',
          customs_documents_pedimento_number: 'Número de pedimento',
          customs_documents_customs_key: 'Clave aduanera',
          customs_documents_pedimento_key: 'Clave de pedimento',
        },
      },
      out: {
        get_in: 'Entrada de activo',
        get_out: 'Salida de activo',
        createdAt: 'Fecha',
        outDate: 'Fecha de Salida',
        time_out: 'Días fuera',
        isOut: 'Estado',
        is_in: 'Dentro',
        is_out: 'Fuera',
        message: 'Mensaje',
        acept_output: 'Aceptar Salida',
        reject_output: 'Rechazar Salida',
        _user_request: 'Solicitado por',
        _user_authorized: 'Autorizado por',
        role_to_acept: 'Authorizacion (Rol)',
        needs_authorization: 'En espera de autorizacion',
        message_required: 'En espera de autorizacion',
        out: 'Salida',
        in: 'Entrada',
        'reject out': 'Rechazo de salida',
        'acept out': 'Aceptación de salida',
        'out request': 'Solicitud de salida',
        status: 'Estatus',
        _employee: 'Responsable',
      },
      disabled: 'Dado de baja',
      disableReason: 'Motivo de baja',
      disableDetail: 'Detalle',
      disableAmount: 'Monto recuperado',
      disableDate: 'Fecha de baja',
      refound: 'Pérdida/Ganancia',
      hasPendingChanges: 'Cambios por revisar',
      _group: 'Grupos Custom',
      _extraDepreciations: 'Depreciaciones adicionales',
      _customsDocuments: 'Pedimentos de importación',
    },
    searchEditor: {
      assets: 'Activos',
      id: 'ID',
      number: 'Número',
      name: 'Nombre',
      description: 'Descripción',
      accountType: 'Cuenta contable',
      assetType: 'Tipo de activo',
      centerCost: 'Centro costos',
      nameEmployee: 'Nombre(s) del empleado',
      lastNameEmployee: 'Apellido(s) del empleado',
      provider: 'Proveedor',
    },
    oldSearchEditor: {
      oldValues: 'Valores viejos',
      id: 'ID',
      number: 'Número',
      name: 'Nombre',
      description: 'Descripción',
      contableAccount: 'Cunta contable',
      assetType: 'Tipo de activo',
      centerCost: 'Centro de costos',
      nameEmployee: 'Nombre(s) del empleado',
      lastNameEmployee: 'Apellido(s) del empleado',
      provider: 'Proveedor',
    },
    changeSearchEditor: {
      changes: 'Cambios',
      value: 'Valores',
    },
    tablesDepreciationColums: {
      year: 'Año',
      period: 'Periodo',
      monthsDepExercise: '#Meses de dep. en el ejercicio',
      totalMonthsDepExercise: 'Total de meses dep. en ejercicios',
      totalMonthsToDep: 'Total de meses a depreciarse',
      factor: 'Factor',
      depMonthly: 'Dep. Mensual',
      depPeriod: 'Dep. Periodo',
      percentajeDepPeriod: '% Dep. Periodo',
      depAccumulated: 'Dep. Acumulada',
      percentajeDepAccumulated: '% Dep. Acumulada',
      valueToDepreciate: 'Valor por depreciar',
    },
  },

  menu: {
    dashboard: 'Dashboard',
    asset_level: 'Nivel de activo',
    control_panel: 'Panel de control',
    configuration: 'Configuración',
    users: 'Usuarios',
    notifications_config: 'Notificaciones',
    notifications_historic: 'Notificaciones',
    roles: 'Roles',
    groups: 'Grupos Custom',
    subcompanies: 'Administrar Empresas',
    subcompanies_add: 'Agregar una Empresa',
    assets: 'Activos',
    maintenance: 'Mantenimiento',
    reports: 'Reportes',
    reports_depreciation: 'Depreciación',
    reports_disabled: 'Bajas',
    reports_historics: 'Historial',
    import: 'Importacion',
    custom_fields_employees: 'Custom Fields',
    employees: 'Empleados',
    accounts: 'Cuentas Contables',
    subaccounts: 'Tipos de activo',
    depreciations: 'Depreciaciones',
    costCenters: 'Centros de costos',
    catalogs: 'Catálogos',
    inpc: 'INPC',
    exchange: 'Tipo de cambio',
    locations: 'Ubicaciones',
    projects: 'Proyectos',
    providers: 'Proveedores',
    actions: {
      logout: 'Cerrar sesión',
      update: 'Editar mi información',
      edit: '',
    },
    reports_reconciliation: 'Conciliación',
    reports_employees_assets: 'Vales de resguardo',
    reports_ins_outs: 'Entradas y Salidas',
    support: 'Ayuda y Soporte',
    maintenance: 'Mantenimiento Alfa',
  },

  catalog: {
    physicalState: {
      name: 'Estado Físico',
      elements: {
        excelent: 'Excelente',
        good: 'Bueno',
        medium: 'Regular',
        bad: 'Malo',
      },
    },
    country: {
      name: 'País',
      elements: {
        mex: 'México',
        usa: 'Estados Unidos de América',
      },
    },
    coin: {
      name: 'Moneda',
      elements: {
        mxn: 'Pesos mexicanos',
        usd: 'Dolares estadounidenses',
        eur: 'Euros',
      },
    },
    buyCondition: {
      name: 'Condición de compra',
      elements: {
        new: 'Nuevo',
        used: 'Usado',
      },
    },
    status: {
      name: 'Estatus',
      elements: {
        depreciating: 'Depreciandose',
        not_depreciating: 'No depreciandose',
        in_construction: 'En construcción',
      },
    },
    disableReason: {
      name: 'Motivo de baja',
      elements: {
        sell: 'Venta',
        damange: 'Daño',
      },
    },
    prefix: {
      name: 'Prefijo',
    },
    depreciationCriteria: {
      name: 'Criterio de depreciación',
      elements: {
        date: 'Fecha de aplicación',
        month: 'Mes siguiente',
      },
    },
    insuranceCarrier: {
      name: 'Aseguradora',
    },
    customs_documents_status: {
      name: 'Estatus de pedimento',
      elements: {
        temporary_importation: 'Importación temporal',
        definitive_importation: 'Importación definitiva',
        returned: 'Devuelto',
        virtual: 'Virtual',
      },
    },
  },

  dashboard: {
    title: 'Dashboard',
    showAssets: 'VER',
    addAsset: 'AGREGAR ACTIVO',
    assetsTotal: 'Número de activos',
    amountTotal: 'Monto total',
    totalByAccounts: 'Activos por cuenta contable',
    totalByCostCenters: 'Activos por centro de costos',
    amountByCostCenters: 'Costo de activos por centro de costos',
    totalByStatus: 'Activos por estatus',
  },

  custom_employee_module: {
    // Para roles
    title: 'Custom Fields',
  },

  custom_employee: {
    // Para roles
    title: 'Custom Fields',
  },

  custom_group: {
    // Para roles
    title: 'Grupos de Custom Fields',
  },
  custom_fields: {
    // Para roles
    title: 'Custom Fields',
  },
  custom_field: {
    // Para roles
    title: 'Custom Fields - Campos',
    empty: 'Empty',
  },

  custom_fields_employees: {
    title: 'Custom Fields',
    employees_title: 'Custom Fields',
    edit: 'Editar Custom Field',
    add: 'Agregar Custom Field',
    fields: {
      key: 'Clave',
      name: 'Nombre',
      active: 'Activo',
      type: 'Tipo',
      description: 'Descripción',
    },
    add: {
      numeric: 'Numérico',
      coin: 'Moneda',
      date: 'Fecha',
      shortText: 'Texto corto',
      LargeText: 'Texto largo',
      dropDwon: 'Desplegable',
      uniqueSelection: 'Selección unica',
      multipleSelection: 'Selección multiple',
      hour: 'Hora',
    },
    searchEditor: {
      key: 'Clave',
      name: 'Nombre',
      type: 'Tipo',
    },
  },
  notifications_config: {
    title: 'Notificaciones Configuración',
  },
  notification_config: {
    title: 'Notificaciones Configuración',
    edit: 'Editar perfil de notificación',
    add: 'Agregar perfil de notificación',
    description: 'Descripción',
    key: 'Código',
    fields: {
      key: 'Clave',
      name: 'Nombre',
      send_mail: 'Enviar Email',
      destinatarios: '# Destinatarios',
      options: '# Opciones',
      active: 'Activo',
      type: 'Tipo',
      description: 'Descripción',
    },
    form: {
      general: 'Datos Generales',
      customFields: 'Notificaciones',
    },
    searchEditor: {
      key: 'Clave',
      name: 'Nombre',
      description: 'Descripción',
    },
  },

  notify: {
    assets: {
      add: 'Agregar activo',
      disable: 'Dar de baja un activo',
      edit: 'Editar un activo',
      edit_request: 'Solicitar edición de activo',
      edit_create_historic: 'Crear histórico de cambio',
      edit_accept: 'Aceptar edición de activo',
      edit_reject: 'Rechazar edición de activo',
      restore: 'Recuperar activo',
      out: 'Salida de activo',
      in: 'Entrada de activo',
      reject_out: 'Rechazo de salida de activo',
      acept_out: 'Se aceptó la salida de activo',
      out_request: 'Solicitud de salida de activo',
    },
  },

  notification_historic: {
    title: 'Notificaciones',
    edit: 'Editar perfil de notificación',
    add: 'Agregar perfil de notificación',
    view_email: 'Ver Email',
    fields: {
      key: 'Clave',
      subject: 'Asunto',
      name: 'Código',
      send_mail: 'Enviar Email',
      destinatarios: '# Destinatarios',
      options: '# Opciones',
      active: 'Activo',
      date: 'Fecha',
      type: 'Tipo',
      description: 'Descripción',
    },
    searchEditor: {
      name: 'Código',
      subject: 'Asunto',
      destinatarios: '# Destinatarios',
    },
  },
  employees: {
    title: 'Empleados',
    employees_title: 'Empleados',
    edit: 'Editar empleado',
    add: 'Agregar empleado',
    fields: {
      key: 'Clave',
      name: 'Nombre',
      lastname: 'Apellido',
      email: 'Correo electrónico',
      position: 'Posición',
      numberAssignedAssets: '# Activos asignados',
      active: 'Activo',
      group: 'Grupo de custom fields',
    },
    searchEditor: {
      key: 'Clave',
      name: 'Nombre',
      lastname: 'Apellido',
      email: 'Correo electrónico',
      position: 'Posición',
    },
  },

  custodyVoucher: {
    signature: 'Firma del resguardante',
    signatureHelp: 'Firma con el dedo, el lápiz o el mouse.',
    clear: 'Limpiar firma',
    downloadForPaper: 'Descargar para firma en papel',
    signAndSave: 'Firmar y guardar',
    withoutPrice: 'Sin precio',
    withPrice: 'Con precio',
    custodian: 'Resguardante',
    assets: 'Activos que ampara',
    reviewHint: 'Para revisar el documento completo, descárgalo para firma en papel.',
    signFromActions: 'Firmar vale de resguardo',
    signGeneral: 'Firmar y guardar',
    newCustodianNotice:
      'El activo cambió de resguardante. Genera el vale del nuevo resguardante en el detalle: ' +
      'Acciones > Firmar vale de resguardo.',
    clearSearchToSign: 'Quita la búsqueda para firmar el vale con todos sus activos.',
  },

  files: {
    locked: 'Firmado',
    voucherCurrent: 'Vigente',
    voucherPrevious: 'Anterior',
    signedFor: 'Resguardante',
    custodianUnknown: 'no registrado',
    signedAt: 'Firmado el',
    preview: 'Vista previa',
    name: 'Nombre',
    default: 'Por defecto',
    actions: 'Acciones',
    status: 'Estatus',
    empty: 'No se han agregado archivos aún',
    pending: 'Por cargar...',
    uploading: 'Cargando...',
    uploaded: 'Cargado',
    fail: 'Falló',
    importing: 'Importando datos...',
    imported: 'Datos importados',
  },

  reports: {
    title: 'Reportes',
    fields: {
      accounts: 'Cuentas',
      subaccounts: 'Tipos',
      costCenters: 'Centros de costos',
      employees: 'Empleados',
      providers: 'Proveedores',
      projects: 'Proyectos',
      depreciationType: 'Tipo de depreciación',
      endDate: 'Fecha de valores',
      status: 'Estatus',
      disabled: 'Desactivados',
      physicalState: 'Estado físico',
      hasPendingChanges: 'Cambios por revisar',
      createdAt: 'Fecha de solicitud',
      reviewDate: 'Fecha de revisión',
      buttonFilters: {
        showFilters: 'Mostrar Filtros',
        hideFilters: 'Ocultar Filtros',
      },
    },
    values: {
      depreciationType: {
        fiscal: 'Fiscal',
        financial: 'Financiera',
      },
    },
    depreciation: {
      title: 'Reporte de depreciación por activo',
      subtitle: 'Reporte de depreciación por activo',
    },
    disabled: {
      title: 'Reporte de activos dados de baja',
      subtitle: 'Reporte de activos dados de baja',
    },
    ins_outs: {
      title: 'Reporte de entrdas y salidas',
      subtitle: 'Reporte de entradas y salidas',
    },
    employeesAssets: {
      hideAssets: 'Ocultar activos asignados',
      showAssets: 'Mostrar activos asignados',
      assigned: 'Activos asignados',
      title: 'Vales de resguardo',
      subtitle: 'Vales de resguardo',
    },
    historics: {
      hideAssets: 'Ocultar cambios',
      showAssets: 'Mostrar cambios',
      assigned: 'Activos asignados',
      title: 'Historial de cambios en Activos',
      subtitle: 'Historial de cambios en Activos',
      fields: {
        status: 'Estatus',
        createdAt: 'Solicitud',
        reviewDate: 'Revisado',
        createdBy: 'Solicitud',
        reviewedBy: 'Revisado',
        key: 'Clave',
        number: 'Número',
        location: 'Ubicación',
        name: 'Activo',
        account: 'Cuenta contable',
        sub_account: 'Tipo de activo',
        costCenter: 'Centro de costos',
        asigned: 'Responsable',
        asigned_status: 'Responsable',
        // asset:{
        //   number
        //   name
        //   description
        //   model
        //   serie
        // }
      },
    },
    searchEditor: {
      assets: 'Activos',
      id: 'ID',
      number: 'Número',
      name: 'Nombre',
      description: 'Descripcion',
      accountType: 'Tipo de cuenta',
      assetType: 'Tipo de activo',
      centerCost: 'Centro de costos',
      nameEmployee: 'Nombre del empleado',
      lastNameEmployee: 'Apellido del empleado',
      provider: 'Proveedor',
    },
    oldSearchEditor: {
      oldValues: 'Valores viejos',
      id: 'ID',
      number: 'Número',
      name: 'Nombre',
      description: 'Descripcion',
      contableAccount: 'Cuenta contable',
      assetType: 'Tipo de activo',
      centerCost: 'Centro de costos',
      nameEmployee: 'Nombre del empleado',
      lastNameEmployee: 'Apellido del empleado',
      provider: 'Proveedor',
    },
    changeSearchEditor: {
      changes: 'Cambios',
      field: 'Campo',
      value: 'Valor',
    },
  },

  import: {
    title: 'Módulo de importación',
    unassigned: 'sin asignar',
    list_subtitle: 'Módulo de importación',
    form_subtitle: 'Importar datos desde un archivo',
    reimport_title: 'Re-Importar',
    reimport:
      "¿Importar nuevamente al modulo: '<strong>{{name}}</strong>'? * <br /><br /> <small>* La acción no se puede deshacer.</small>",
    error: {
      verify: 'Selecciona un archivo para importarlo',
      fileType: 'Error al seleccionar archivo, sólo se permiten csv.',
      importing:
        'Ocurrió un error al tratar de importar el archivo, puede que el archivo este dañado o no tenga el formato correcto',
    },
    modules: {
      assets: 'Activos',
      providers: 'Proveedores',
      projects: 'Proyectos',
      cost_centers: 'Centros de costos',
      cuenta_contable: 'Cuentas contables',
      tipo_activo: 'Tipos de activo',
      custom_employees: 'Custom fields empleados',
      employees: 'Empleados',
      locations: 'Ubicaciones',
    },
    fields: {
      files: 'Archivo',
      module: 'Módulo',
      createdAt: 'Fecha de importación',
      status: 'Estatus',
      updated: '# Registros actualizados',
      inserted: '# Registros creados',
      fail: '# Registros fallidos',
      warnings: '# Advertencias',
      import: 'Re-importar',
      selectHeaders: 'Seleccionar los Headers',
      actions: 'Acciones',
      file: 'Archivo',
      download: 'Descargar CSV',
      csvTemplateAssets: 'Plantilla CSV Activos',
    },
    showDetailsFields: {
      showDetails: 'Mostrar detalles',
      hideDetails: 'Ocultar detalles',
      new: 'Nuevo',
      success: 'Éxito',
      warning: 'Advertencias',
      wrongs: 'Errores',
    },
    searchEditor: {
      assets: 'Activos',
      provider: 'Proveedores',
      projects: 'Proyectos',
      costCenter: 'Centros de costos',
      ledgerAccounts: 'Cuentas contables',
      typeAssets: 'Tipos de activo',
      customFieldsEmployees: 'Custom fields empleados',
      employees: 'Empleados',
      locations: 'Ubicaciones',
    },
  },
  exchanges: {
    title: 'Tipos de cambio',
  },
  exchange: {
    title: 'Tipos de cambio',
    exchange_title: 'Tipos de cambio',
    edit: 'Editar Tipo de cambio',
    add: 'Agregar Tipo de cambio',
    fields: {
      fromCurrency: 'Moneda Origen',
      toCurrency: 'Moneda Destino',
      value: 'Valor',
      date: 'Fecha',
    },
  },

  cost_centers: {
    title: 'Centros de costos',
  },

  costCenters: {
    title: 'Centros de costos',
    costCenters_title: 'Centros de costos',
    edit: 'Editar Centro de costos',
    add: 'Agregar Centro de costos',
    fields: {
      key: 'Clave',
      name: 'Nombre',
      description: 'Descripción',
      active: 'Activo',
    },
    searchEditor: {
      key: 'Clave',
      name: 'Nombre',
      description: 'Descripción',
    },
  },

  providers_clients: {
    title: 'Proveedores',
  },

  catalogs: {
    title: 'Catálogos',
    catalogs_title: 'Catálogos',
    edit: 'Editar catálogo',
    form: {
      general: 'Datos generales',
      elements: 'Elementos del catálogo',
    },
    fields: {
      key: 'Clave',
      name: 'Nombre',
      value: 'Valor',
      elements: 'Elementos',
      active: 'Activo',
    },
    searchEditor: {
      key: 'Clave',
    },
  },

  accounts: {
    title: 'Cuentas Contables y Tipos de Activo',
    accounts_title: 'Cuentas Contables',
    edit: 'Editar Cuenta Contable',
    add: 'Agregar Cuenta Contable',
    form: {
      general: 'Datos generales',
      depreciations: 'Depreciación',
      customFields: 'Campos personalizados',
    },
    fields: {
      key: 'Clave',
      name: 'Nombre',
      description: 'Descripción',
      active: 'Activo',
      fiscalDepreciation: 'Depreciación Fiscal',
      financialDepreciation: 'Depreciación Financiera',
      customFields: {
        key: 'Llave',
        label: 'Etiqueta',
        unique: 'Campo único',
        dependent: 'Valor Dependiente',
      },
    },
    searchEditor: {
      key: 'Clave',
      name: 'Nombre',
      description: 'Descripción',
    },
  },

  subaccounts: {
    subaccounts_title: 'Tipos de activo',
    edit: 'Editar Tipo de activo',
    add: 'Agregar Tipo de activo',
    form: {
      general: 'Datos generales',
      depreciations: 'Depreciación',
      customFields: 'Campos personalizados',
    },
    fields: {
      key: 'Clave',
      name: 'Nombre',
      description: 'Descripción',
      active: 'Activo',
      parent: 'Cuenta contable',
      fiscalDepreciation: 'Depreciación Fiscal',
      financialDepreciation: 'Depreciación Financiera',
      customFields: {
        key: 'Llave',
        label: 'Etiqueta',
      },
    },
    searchEditor: {
      key: 'Clave',
      name: 'Nombre',
      description: 'Descripción',
      parent: 'Cuenta contable',
    },
  },

  depreciations: {
    title: 'Depreciaciones',
    depreciations_title: 'Depreciaciones',
    edit: 'Editar Depreciación',
    add: 'Agregar Depreciación',
    form: {
      general: 'Datos generales',
      percents: 'Porcentajes de depreciación',
    },
    fields: {
      key: 'Clave',
      name: 'Nombre',
      active: 'Activo',
      maximumAmount: 'Monto máximo a depreciar',
      maximumPercent: 'Porcentaje máximo a depreciar',
      criteria: 'Criterio',
      year: 'Año',
      percentage: 'Porcentaje',
      total: 'Total',
      monthslastyear: 'Meses el último año',
    },
    searchEditor: {
      key: 'Clave',
      name: 'Nombre',
    },
  },

  inpc: {
    inpc_title: 'Índice Nacional de Precios al Consumidor',
    title: 'INPC',
    edit: 'Editar INPC',
    add: 'Agregar INPC',
    form: {
      general: 'Datos generales',
      percents: 'Porcentajes de depreciación',
    },
    fields: {
      key: 'Clave',
      name: 'Nombre',
      active: 'Activo',
      maximumAmount: 'Monto máximo depreciable',
      criteria: 'Criterio',
      year: 'Año',
      percentage: 'Porcentaje',
      total: 'Total',
    },
    searchEditor: {
      year: 'Año',
    },
  },

  locations: {
    title: 'Ubicaciones',
    locations_title: 'Ubicaciones',
  },

  projects: {
    fields: {
      key: 'Clave',
      name: 'Nombre',
      amount: 'Importe',
      active: 'Activo',
    },
    searchEditor: {
      key: 'Clave',
      name: 'Nombre',
      amount: 'Importe',
      active: 'Activo',
    },
    title: 'Proyectos',
    edit: 'Editar proyecto',
    add: 'Agregar proyecto',
  },
  asset_level: {
    fields: {
      key: 'Clave',
      name: 'Nombre',
      max_time: 'Maximos días fuera',
      message_required: 'Necesita mensaje',
      can_withdrawn: 'Se puede retirar',
      role_to_acept: 'Requiere aceptación de',
      active: 'Activo',
    },
    searchEditor: {
      key: 'Clave',
      name: 'Nombre',
      amount: 'Importe',
    },
    title: 'Nivel de Activo',
    edit: 'Editar nivel de activo',
    add: 'Agregar nivel de activo',
  },
  ins_outs: {
    title: 'Entradas y Salidas',
  },

  providers: {
    fields: {
      key: 'Clave',
      name: 'Nombre',
      mail: 'Correo electrónico',
      telephone: 'Teléfono',
      rfc: 'RFC',
      active: 'Activo',
    },
    searchEditor: {
      key: 'Clave',
      name: 'Nombre',
      mail: 'Correo electrónico',
      telephone: 'Teléfono',
      rfc: 'RFC',
    },
    title: 'Proveedores',
    edit: 'Editar proveedor',
    add: 'Agregar proveedor',
  },

  mantenimiento: {
    title: 'Mantenimiento',
  },
  mantenimiento_module: {
    title: 'Mantenimiento Módulo (Extra)',
    edit: 'Editar',
    add: 'Agregar a mantenimiento',
    fields: {
      key: 'Clave',
      name: 'Nombre',
      mail: 'Correo electrónico',
      telephone: 'Teléfono',
      rfc: 'RFC',
      active: 'Activo',
    },
  },

  asset_employeePDF: {
    title: 'Vale de Resguardo',
    date: 'Fecha',
    employee: 'Empleado',
    position: 'Puesto',
    id: 'Clave empleado',
    table: {
      number: 'Número',
      name: 'Nombre',
      brand: 'Marca',
      model: 'Modelo',
      serie: 'Número de Serie',
    },
    message: {
      title: 'Recibí el equipo que se menciona a continuación:',
      content:
        'El cual me comprometo a cuidar, mantener en buen estado y utilizar única y exclusivamente para asuntos relacionados con mi actividad laboral. En caso de su extravío, daño ó uso inadecuado, me responsabilizo a pagar el costo de reparación o la reposición del equipo.',
    },
    receive: 'Recibe',
    out: {
      title: 'Entradas y Salidas',
      date: 'Fecha de Solicitud',
      outDate: 'Fecha de Salida',
      max_time: 'Máximos Días Fuera',
      outDays: 'Días Fuera',
      isOut: {
        title: 'Estado',
        outside: 'Fuera',
        indoors: 'Adentro',
        onHold: 'En espera de autorización',
      },
      employee: 'Responsable',
      user_request: 'Solicitado por',
      user_authorized: 'Autorizado por',
      message: 'Mensaje',
    },
  },
  info: {
    noResults: 'No se encontraron resultados',
    tooltip: {
      asset_module: {
        sum_of_amounts_and_records:
          'Los montos calculados se basan en el tipo de cambio registrado para cada activo. Si el tipo de cambio no está asignado, se utilizará un valor predeterminado de 1.',
      },
    },
  },
  clients: {
    title: 'Clientes',
    add: 'Agregar cliente',
    searchEditor: {
      key: 'Clave',
      name: 'Nombre',
      mail: 'Correo electrónico',
      telephone: 'Teléfono',
      rfc: 'RFC',
    },
    fields: {
      key: 'Clave',
      name: 'Nombre',
      mail: 'Correo electrónico',
      telephone: 'Teléfono',
      rfc: 'RFC',
      active: 'Activo',
    },
  }
};



// WEBPACK FOOTER //
// src/locales/es.js